<p-button label='Schliessen' icon='pi pi-map'
          (onClick)="close()"
          severity="info">
</p-button>
